
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import SchedulingTable from "@/components/SchedulingTable.vue"
import SchedulingUserEntry from "@/components/SchedulingUserEntry.vue"


@Component({
  components: {
    SchedulingTable,
    SchedulingUserEntry
  }
})

export default class ModalSchedulingTable extends Mixins(Common) {
  @Prop({type: String, default: ''}) private schedulingSheetId?: string
  @Prop({type: String, default: ''}) private entryUser?: string
  @Prop({type: String, default: ''}) private title?: string
  /*
  
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string

  //
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  */

  isLoading: boolean | string = false

  isActive = true

  showEntry = false

  async created(){
    try{
      this.showEntry = ! this.isStaff
    }catch(error){
      console.log(error)
    }
  }

  async goToSchedulingPage(){
    const location = {
      name: '',
      query: {},
    }

    location.name = 'schedulingList'
    location.query = {schedulingId: this.schedulingSheetId}
    
    await this.$router.push(location)
  }

  mounted(){
    //
  }
/*
  selectAction(type: string){
    this.$emit("selectAction",{
      type: type,
      eventId: this.theEventData?.id
    });
  }
*/
  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes)
  }

  get schoolId(): string{
    return this.$store.getters.schoolId
  }

  get isStaff(){
    return this.$store.getters.isStaff
  }

  destroyed() {
    console.trace('destroyed');
  }
}
